const React = require('react');
const { createElement: h, useState, useEffect } = React;
const GoogleScopePickerModal = require('./GoogleScopePickerModal');
const picker = require('../lib/googleScopePicker');

// Mounted ONCE at the app root. Renders the Google scope-picker modal on demand
// when any component calls picker.openGoogleScopePicker(). Bridges the modal's
// confirm/cancel back to the pending promise so callers get { name, scopes }.
function GoogleScopePickerHost() {
  var [open, setOpen] = useState(false);

  useEffect(function() {
    return picker._subscribe(function(shouldOpen) { setOpen(!!shouldOpen); });
  }, []);

  if (!open) return null;

  return h(GoogleScopePickerModal, {
    onConfirm: function(selection) { picker._resolvePending(selection); },
    onCancel: function() { picker._rejectPending(); }
  });
}

module.exports = GoogleScopePickerHost;
